/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Space, rem, useMantineTheme, Box, Stack, Text, Title } from '@mantine/core';
import { RiErrorWarningLine } from '@remixicon/react';

import { TextVariants, TitleVariants } from '@fai/ui/components/typography/variants';

function ErrorPage({ title, message }: { title: string; message: string }) {
  const theme = useMantineTheme();

  return (
    <Stack
      align="center"
      gap={theme.pf.layout.lg}
      mx="auto"
      px={theme.pf.layout.sm}
      w={{
        base: '100%',
        lg: rem(1000),
      }}
    >
      <Space h={theme.pf.layout['3xl']} />
      <RiErrorWarningLine color={theme.pf.color.fg.danger.default.base} size={64} />
      <Title variant={TitleVariants.Xl}>{title}</Title>
      <Box
        px={theme.pf.layout.sm}
        py={theme.pf.layout.md}
        bd={`1px solid ${theme.pf.color.border.neutral.default}`}
        style={{ borderRadius: theme.pf.radius.md }}
        w="100%"
      >
        <Text mx="auto" variant={TextVariants.BodyMd} w="fit-content">
          {message}
        </Text>
      </Box>
    </Stack>
  );
}

export default ErrorPage;
